export default __webpack_public_path__ + "static/media/brand-logo.ec9e2c9d.png";